import { render, staticRenderFns } from "./iRadiosField.vue?vue&type=template&id=75ce8fbd&"
import script from "./iRadiosField.vue?vue&type=script&lang=js&"
export * from "./iRadiosField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports